import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeGetPanelNotificationsCount } from 'selectors/notifications';

import { openFlyout } from 'actions/flyout';

import Tooltip from 'components/tooltip';
import NotificationsBubble from 'components/NotificationsBubble';

import IconActivity from 'icons/icon-activity';

import './AppNotificationsToggle.styles.css';

const AppNotificationsToggle = ({ notificationsCount }) => {
    const { t } = useTranslation('notifications');

    const handleClick = () => {
        openFlyout('activity', {
            arrowClose: true
        });
    }

    return (
        <div className="app-notifications-toggle" onClick={handleClick}>
            <Tooltip placement="bottom" tooltip={ t('Notifications') } withTooltipHover={false}>
                <span className="icon-holder"><IconActivity /></span>
            </Tooltip>

            <NotificationsBubble count={notificationsCount} />
        </div>
    )
}

const makeMapStateToProps = () => {
    const getPanelNotificationsCount = makeGetPanelNotificationsCount();

    return ({ notifications }) => ({
        notificationsCount: getPanelNotificationsCount(notifications.items)
    });
}

export default connect(makeMapStateToProps)(AppNotificationsToggle);
